import { LogbookActionEnum } from "../enums"
import { ReducerAction, StateLogbook } from "../types"
import { checkUser, editError, editLoadState, editUuId, searchUsers, selectUser } from "./activity"
import { logbookActivitySection } from "./activitySection"
import { logbookLoadings } from "./loadings"
import { saveUserActivitiesMark, userListMap } from "./map"
import { changeTab } from "./tab"
import { test } from "./test"

export const reducer = (state: StateLogbook, action: ReducerAction): StateLogbook => {
    switch (action.type) {
        case LogbookActionEnum.TEST: { return test(state, action) }
        case LogbookActionEnum.CHANGE_TAB: { return changeTab(state, action.payload) }
        case LogbookActionEnum.SEARCH_USERS: { return searchUsers(state, action.payload) }
        case LogbookActionEnum.SELECT_USER_TO_ASSIGN: { return selectUser(state, action.payload) }
        case LogbookActionEnum.SAVE_USER_LIST_MAP: { return userListMap(state, action.payload) }
        case LogbookActionEnum.LOADINGS: { return logbookLoadings(state, action.payload) }
        case LogbookActionEnum.ACTIVITY_SECTION: { return logbookActivitySection(state, action.payload) }
        case LogbookActionEnum.SAVE_USER_ACTIVITIES_MARK: { return saveUserActivitiesMark(state, action.payload) }
        case LogbookActionEnum.CHECK_USER: { return checkUser(state, action.payload) }
        case LogbookActionEnum.EDIT_UUID: {return editUuId(state, action.payload) }
        case LogbookActionEnum.EDIT_ERROR: {return editError(state, action.payload) }
        case LogbookActionEnum.LOAD_STATE: {return editLoadState(state, action.payload) }
        default: return state
    }
}